import { NavBar } from 'components/NavBar/NavBar'
import { NoItems } from 'components/NoItems-fallback/NoItems'
import { Pagination } from 'components/Pagination/Pagination'
import { Td } from 'components/Td/Td'
import useQueryPagination from 'hooks/useQueryPagination'
import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { AppDispatch, RootState } from 'store'
import { Button, Flex, MainHeadline, PageFooter, PageWrapper, Table, Th, Tr } from 'styling/GlobalStyles'
import { formatDateForDisplay, getParams, handlePagination } from 'utils/helpers'
import {
    approveInventoryAssignment,
    clearInventoryAssignments,
    declineInventoryAssignment,
    getInventoryAssignments,
} from 'features/inventory/inventoryItemsSlice'
import { Options } from 'components/Options/Options'
import { useNavigate } from 'react-router-dom'
import { setConfirmModal } from 'features/global/globalSlice'
import { ModalTypes } from 'types/global.interface'
import { FilterEnum } from 'components/Filter/SingleFilter'
import { IGetAllInventoryAssignmentsSingleResponse } from 'types/api/inventoryItems.interface'
import { ViewInventoryAssignmentModal } from './ViewInventoryAssignmentModal'

export const InventoryAssignments = () => {
    const { assignments } = useSelector((store: RootState) => store.inventoryItems)
    const [params, setParams] = useState<any>(getParams({ location }))
    const dispatch = useDispatch<AppDispatch>()
    const navigate = useNavigate()
    const [viewModal, setViewModal] = useState<{ open: boolean, value: IGetAllInventoryAssignmentsSingleResponse }>({ open: false, value: null })

    useQueryPagination({ fetchFunctions: [getInventoryAssignments], cleanUpFunctions: [clearInventoryAssignments], params })

    const handleRequest = (id: number, approve: boolean, item: IGetAllInventoryAssignmentsSingleResponse) => {
        if (item) {
            setViewModal({ open: true, value: item })
            return
        }
        dispatch(
            setConfirmModal({
                isOpen: true,
                onSave: async () => {
                    await dispatch(approve ? approveInventoryAssignment(id) : declineInventoryAssignment(id))
                },
                setParams: {
                    type: ModalTypes.BeforeSabe,
                    f: setParams,
                    noItems: assignments.data.length < 2,
                },
                word: approve ? 'approve this assignment' : 'decline this assignment',
            }),
        )
    }

    const filters = [
        {
            type: FilterEnum.SELECT,
            name: 'Status',
            options: inventoryAssignmentStatuses,
            propName: 'status'
        },
    ]

    return <>
        <NavBar enableTemporaryManualClosing filterOptions={filters} visibleFilterOverflow setParams={setParams} />
        <PageWrapper>
            <Flex between center mb='16' >
                <MainHeadline>Inventory Assignments</MainHeadline>
                <Button orange onClick={() => navigate('add')} >Add Assignment</Button>
            </Flex>
            {!assignments?.data?.length ? (
                <NoItems title='Assignments' />
            ) : (
                <Table width='100%' >
                    <Th next>
                        <Td w='20%' noTooltip text='TYPE' />
                        <Td w='20%' noTooltip text='LOCATION' />
                        <Td w='20%' noTooltip text='STATUS' />
                        <Td w='20%' noTooltip text='DATE' />
                        <Td w='35%' noTooltip text='ITEMS' />
                        <Td w='5%' noTooltip />
                    </Th>
                    {assignments?.data.map((item) => {
                        return (
                            <Tr view onClick={() => handleRequest(item.id, false, item)} key={item.id}>
                                <Td w='20%' text={item.type == 1 ? 'Assign' : 'Unassign'} />
                                <Td w='20%' text={item.location?.name || '/'} />
                                <Td w='20%' text={inventoryAssignmentStatuses.find(s => s.value == item.status).label || '/'} />
                                <Td w='20%' text={formatDateForDisplay(item.createdAt)} />
                                <Td w='35%' text={item.lines?.length || '0'} />
                                <Td w='5%' options >
                                    <Options item={item} title='Assignments' openModal={handleRequest} />
                                </Td>
                            </Tr>
                        )
                    })}
                </Table>
            )}
            {viewModal.open && <ViewInventoryAssignmentModal value={viewModal.value} closeModal={() => setViewModal({ value: null, open: false })} />}
        </PageWrapper>
        <PageFooter>
            <Pagination
                setPage={(page) => handlePagination(page, setParams, 30)}
                pageCount={Math.ceil(assignments?.totalPages)}
                forcePage={(params.page ? params.page : 1) - 1}
            />
        </PageFooter>
    </>
}

export const inventoryAssignmentStatuses = [
    { label: 'Pending', value: 1 },
    { label: 'Approved', value: 2 },
    { label: 'Declined', value: 3 }
]
